import { CONTROL_STATE_OFF, CONTROL_STATE_ON } from '@apps-common/config/controls'
import { commonIcons } from '@apps-common/config/icons'
import { ResolvedControlTheme } from '@apps-common/hooks/useControlTheme'
import classNames from 'classnames'

interface IProps {
  colors: ResolvedControlTheme
  state: string
}

export const HistoryState: React.FC<IProps> = ({ colors, state }) => {
  return (
    <div
      className={classNames(
        'absolute bottom-0 right-0 m-[7px] uppercase jost-medium text-[0.7em] leading-[1em] px-[22px] w-[50px] h-[50px] rounded-[20px] flex flex-col items-center justify-center gap-[5px]',
        'opacity-80',
        colors.bg,
        colors.text,
        colors.border
      )}
    >
      <div className='text-[1.3em] pt-[2px]'>
        {state === CONTROL_STATE_ON && <commonIcons.powerAlt />}
        {state === CONTROL_STATE_OFF && <commonIcons.powerOffAlt />}
      </div>
      <div>{state}</div>
    </div>
  )
}
